import {useMemo} from "react";
import {useSelector} from "react-redux";
import dayjs from "dayjs";
import Card from "../../util/card/Card.jsx";
import './HistoryStatsCard.scss'
import {getHistoryArray, getIsStatsCardVisible} from "../../../ducks/history-duck.js";
import {getAssetIds} from "../../../ducks/assets-duck.js";
import {DECIMAL_FORMAT, median, numberFormat} from "../../../util/numbers.js";

const PERIODS = [
    {label: 'Past 3 years', unit: 'year', amount: 3},
    {label: 'Past year', unit: 'year', amount: 1},
    {label: 'Past 3 months', unit: 'month', amount: 3},
    {label: 'Past month', unit: 'month', amount: 1},
]

export default () => {

    const isVisible = useSelector(getIsStatsCardVisible)
    const history = useSelector(getHistoryArray)
    const assetIds = useSelector(getAssetIds)

    const dailyChanges = useMemo(() => history.map(([date, data]) => {
        const {gainChange, valueYesterday} = assetIds.reduce((acc, cur) => ({
            valueYesterday: acc.valueYesterday + data[cur].valueYesterday,
            gainChange: acc.gainChange + (data[cur].value - (data[cur].value / (1 + data[cur].gainChangePercent))),
        }), {valueYesterday: 0, gainChange: 0})
        return {
            date,
            absKr: Math.abs(gainChange),
            absPercent: valueYesterday !== 0 ? Math.abs(gainChange / valueYesterday) * 100 : 0,
        }
    }), [history, assetIds])

    return isVisible && (
        <div className='history-stats-card'>
            <Card>
                <div className='periods'>
                    {PERIODS.map(({label, unit, amount}) =>
                        <Period
                            key={label}
                            label={label}
                            dailyChanges={dailyChanges}
                            cutoff={dayjs().subtract(amount, unit)}
                        />)
                    }
                </div>
            </Card>
        </div>
    )
}

const Period = ({label, dailyChanges, cutoff}) => {

    const changesInRange = dailyChanges.filter(({date}) => dayjs(date).isAfter(cutoff))
    const krValues = changesInRange.map(({absKr}) => absKr).filter(Number.isFinite)
    const percentValues = changesInRange.map(({absPercent}) => absPercent).filter(Number.isFinite)

    const medianKr = krValues.length ? median(krValues) : 0
    const medianPercent = percentValues.length ? median(percentValues) : 0

    return (
        <div className='period'>
            <div className='period-label small weak'>
                {label}
            </div>
            <div className='period-value'>
                kr {numberFormat(medianKr, DECIMAL_FORMAT.FLEX_DEC)}
            </div>
            <div className='period-percent small weak'>
                {numberFormat(medianPercent, DECIMAL_FORMAT.FLEX_PERCENTAGE)}%
            </div>
        </div>
    )
}
